import { render, staticRenderFns } from "./create-tenant.vue?vue&type=template&id=e9f21030&scoped=true&"
import script from "./create-tenant.ts?vue&type=script&lang=ts&"
export * from "./create-tenant.ts?vue&type=script&lang=ts&"
import style0 from "./create-tenant.scss?vue&type=style&index=0&id=e9f21030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f21030",
  null
  
)

export default component.exports